import React, { Component } from 'react';  // eslint-disable-line no-unused-vars
import { Button } from 'antd';

export default function BtnLogin(props){
  return(
    <Button className="btn-login" size="large" key={props.btnKey}>
      <img alt={props.alt} src={props.src} />
      {props.children}
    </Button>
  )
}



// WEBPACK FOOTER //
// ./src/components/Buttons/BtnLogin.js